import React from "react";
import { useContext } from "react";
import { Link } from "react-router-dom";
import FuncionesContext, {
  getAtributo,
} from "../../../context/FuncionesContext";
import Default from "./Default";
import { construirEnlace } from "../../../helper/funciones";

const Enlace = ({ data, cab, hijos, campokey, indiceData, id_elemento }) => {
  const { enviarAModal } = useContext(FuncionesContext);

  const e = cab.enlace
    ? cab.enlace_alias
      ? data[cab.enlace_alias]
        ? data[cab.enlace_alias]
        : cab.enlace
      : cab.enlace
    : "";

  // const parametros_valores = cab.enlace_parametros_alias
  //   ? data[cab.enlace_parametros_alias]
  //     ? data[cab.enlace_parametros_alias]?.toString().split(",")
  //     : cab.enlace_parametros?.toString().split(",")
  //   : undefined;

  // const en = cab.enlace_parametros_nombres_alias
  //   ? data[cab.enlace_parametros_nombres_alias]
  //     ? data[cab.enlace_parametros_nombres_alias]?.toString().split(",")
  //     : cab.enlace_parametros_nombres?.toString().split(",")
  //   : cab.enlace_parametros_nombres?.toString().split(",");

  // const id_a = data[cab.enlace_id_a_alias]
  //   ? data[cab.enlace_id_a_alias]
  //   : cab.enlace_id_a
  //   ? cab.enlace_id_a
  //   : "";

  // let parametros = "";
  // let paramObj = {};
  // if (parametros_valores && en) {
  //   parametros = "?";
  //   parametros_valores.forEach((qP, i) => {
  //     parametros = parametros.concat("&" + en[i] + "=" + qP);
  //     paramObj[en[i]] = qP;
  //   });
  // }

  // const enlace =
  //   cab.enlace_externo === "s"
  //     ? e + parametros
  //     : process.env.PUBLIC_URL + "/#" + e + id_a + parametros;

  const enlaceObj = construirEnlace(data, cab);


  const disabled = getAtributo("disabled", data, cab);
  const boton_texto = getAtributo("boton_texto", data, cab);
  if (disabled === "s")
    return (
      <Default
        data={data}
        cab={cab}
        hijos={hijos}
        campokey={campokey}
        id_elemento={id_elemento}
      />
    );

  if (cab.target === "modal") {
    return (
      <div
        onClick={() =>
          enviarAModal(cab.enlace_id_a, enlaceObj.params, {
            min_width_modal: cab.min_width_modal,
          })
        }
        id={id_elemento}
        className={`${cab.className} Listado_Switch_Enlace`}
      >
        {cab.imagen_url ? (
          <img
            style={{ cursor: "pointer" }}
            height={"40px"}
            src={cab.imagen_url}
            alt="imagen"
          />
        ) : (
          <>
            {boton_texto}
          </>
        )}
      </div>
    );
  }

  if (cab.target === "_blank") {
    return (
      <div id={id_elemento} className="Listado_Switch_Enlace">
        <Ancla
          cab={cab}
          enlace={enlaceObj.enlace_completo}
          data={data}
          hijos={hijos}
          target={cab.target}
        />
      </div>
    );
  }

  if (cab.target === "descarga") {
    const archivo_nombre =
      data[cab.id_a + "_archivo_nombre"] ??
      cab.archivo_nombre ??
      e.split("/").pop();
    return (
      <div
        id={id_elemento}
        className={`Listado_Switch_Enlace ${data[cab.id_a + "_className"]}`}
        style={{ width: "min-content" }}
      >
        <a
          id={id_elemento + "_a"}
          href={e}
          rel="noopener noreferrer"
          download={archivo_nombre}
        >
          <div
            style={{
              textAlign: cab.align ?? "center",
            }}
          >
            {cab.imagen_url ? (
              <img
                style={{ cursor: "pointer" }}
                height={"40px"}
                src={cab.imagen_url}
                alt="imagen"
              />
            ) : (
              <>
                {boton_texto}
              </>
            )}

            {hijos}
          </div>
        </a>
      </div>
    );
  }

  return (
    <div id={id_elemento} className={`Listado_Switch_Enlace ${cab.className}`}>
      {cab.enlace_externo === "s" ? (
        <Ancla
          cab={cab}
          enlace={enlaceObj.enlace_completo}
          data={data}
          hijos={hijos}
          target="_self"
        />
      ) : (
        <Link
          to={{
            pathname: `/${enlaceObj.enlace}`,
            search: enlaceObj.parametros,
            target: cab.target,
          }}
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            {cab.imagen_url ? (
              <img
                style={{ cursor: "pointer" }}
                height={"40px"}
                src={cab.imagen_url}
                alt="imagen"
              />
            ) : (
              <>
                {boton_texto}
              </>
            )}

            {hijos}
          </div>
        </Link>
      )}
    </div>
  );
};

export default Enlace;

const Ancla = ({ cab, enlace, data, hijos, target }) => {
  const boton_texto = getAtributo("boton_texto", data, cab)
  return (
    <a target={target} href={enlace} rel="noopener noreferrer">
      <div
        style={{
          textAlign: cab.align ?? "left",
        }}
        className={`${cab.className}`}
      >
        {cab.imagen_url ? (
          <img
            style={{ cursor: "pointer" }}
            height={"40px"}
            src={cab.imagen_url}
            alt="imagen"
          />
        ) : (
          <>
            {boton_texto}
          </>
        )}

        {hijos}
      </div>
    </a>
  );
};
